import { createRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Search } from 'lucide-react'
import { publicLayoutRoute } from '@/ui/pages/public'
import { useAuthStore } from '@/application/stores/auth.store'
import { useDocumentMeta } from '@/application/hooks/useDocumentMeta'
import { OG_IMAGE_URL } from '@/application/seo/site'
import { useLocalizedUrl } from '@/application/hooks/useLocalizedUrl'
import { Breadcrumb } from '@/ui/components/common/Breadcrumb'
import { BreadcrumbJsonLd } from '@/ui/components/public/BreadcrumbJsonLd'
import { Button } from '@/ui/components/common/Button'
import { InvestigationsListSection } from './components/InvestigationsListSection'
import { SuggestDialog } from './components/SuggestDialog'

export const publicInvestigationsRoute = createRoute({
  getParentRoute: () => publicLayoutRoute,
  path: 'investigations',
  component: PublicInvestigationsListPage,
})

export function PublicInvestigationsListPage() {
  const { t } = useTranslation()
  const { isAuthenticated } = useAuthStore()
  const [showSuggestForm, setShowSuggestForm] = useState(false)

  const pageUrl = useLocalizedUrl('/investigations')

  useDocumentMeta({
    title: t('seo.investigations_title'),
    description: t('seo.investigations_description'),
    imageUrl: OG_IMAGE_URL,
    url: pageUrl,
    type: 'website',
  })

  const breadcrumbItems = [
    { label: t('nav.home'), href: '/' },
    { label: t('investigations.page_title') },
  ]

  return (
    <div className="m-auto w-full max-w-[100rem] bg-card grow px-8 py-10">
      <BreadcrumbJsonLd items={breadcrumbItems} currentUrl={pageUrl} />
      <Breadcrumb items={breadcrumbItems} />

      <div className="mb-6">
        <div className="flex items-start justify-between gap-4">
          <h1 className="font-serif text-4xl font-black">{t('investigations.page_title')}</h1>
          {isAuthenticated && (
            <Button
              onClick={() => setShowSuggestForm(true)}
              leftIcon={<Search className="w-4 h-4" />}
            >
              {t('investigations.suggest_new')}
            </Button>
          )}
        </div>
        <div className="h-1 w-16 bg-primary mt-2" />
      </div>

      <InvestigationsListSection />

      <SuggestDialog open={showSuggestForm} onOpenChange={setShowSuggestForm} />
    </div>
  )
}
